import React from 'react';
import { BookOpenIcon, FlaskConicalIcon } from 'lucide-react';
import { Section } from './Shared';
import { Blossom } from './FloralDecor';
type Tome = {
  label: string;
  title: string;
  subtitle: string;
  icon: React.ElementType;
  cover: string;
  coverAlt: string;
  features: string[];
};
const tomes: Tome[] = [{
  label: 'TOMO I',
  title: 'El Manual de Intervención de Campo',
  subtitle: 'Protocolos de respuesta inmediata para crisis en consulta',
  icon: BookOpenIcon,
  cover: 'https://cdn.magicpatterns.com/uploads/r5ShgTL2jgZLwhnVjTdFdh/ChatGPT_Image_25_ago_2026,_14_30_49.png',
  coverAlt: 'Portada del Tomo I: El Manual de Intervención de Campo, Botiquín Bach',
  features: ['Los 5 signos de alerta que identifican una crisis en los primeros 60 segundos', 'Protocolo Rojo: cómo intervenir en pánico agudo (5-10 minutos)', 'Protocolo Azul: manejo de angustia profunda y duelo (15-20 minutos)', 'Protocolo Negro: control de descontrol y brotes de rabia (5-10 minutos)', 'El código de los 60 segundos: lectura de lenguaje corporal en crisis', 'Sistema de goteo acelerado: dosificación correcta en emergencias', 'Qué decir (y qué NO decir) al paciente en cada momento', 'Casos de estudio reales: protocolo paso a paso', '50 páginas de contenido tácticamente organizado']
}, {
  label: 'TOMO II',
  title: 'Las 15 Fórmulas Maestras “Copy-Paste”',
  subtitle: 'El recetario exacto: cada fórmula lista para aplicar',
  icon: FlaskConicalIcon,
  cover: 'https://cdn.magicpatterns.com/uploads/4tU1dJ7XrjNuTQ7YiQmhVt/ChatGPT_Image_25_ago_2026,_14_40_41.png',
  coverAlt: 'Portada del Tomo II: Las 15 Fórmulas Maestras, Botiquín Bach',
  features: ['Fórmulas #1-5: las 5 de emergencia inmediata (pánico, angustia, descontrol, disociación, shock)', 'Fórmulas #6-10: combinaciones tácticas para crisis complejas', 'Fórmulas #11-15: cierres, protección y recuperación del terapeuta', 'Cada fórmula incluye composición exacta, método, frecuencia, duración y señales de éxito', 'Variantes por intensidad de crisis (leve, moderada, severa)', 'Método del vaso de agua: la técnica que acelera la absorción 3x', 'Combinación tópica + oral: protocolo ultra-potente para crisis severas', '50 páginas de recetas precisas, sin teoría innecesaria']
}];
const bonuses = [{
  number: '01',
  title: 'Placa Visual de Emergencia',
  pages: '10 páginas',
  cover: 'https://cdn.magicpatterns.com/uploads/4r9WGjPviP5wSqVNkHhxjX/Captura_de_pantalla_2026-08-25_155247.png'
}, {
  number: '02',
  title: 'Guía de Bach Tópico',
  pages: '15 páginas',
  cover: 'https://cdn.magicpatterns.com/uploads/x9M2ykLNLoQkJgwu7Po3uJ/ChatGPT_Image_25_ago_2026,_14_51_13.png'
}, {
  number: '03',
  title: 'Ficha de Registro de Crisis',
  pages: '15 páginas',
  cover: 'https://cdn.magicpatterns.com/uploads/waxK5m9rPTsHJ414zngBGW/Captura_de_pantalla_2026-08-25_155315.png'
}, {
  number: '04',
  title: 'El Escudo del Terapeuta',
  pages: '20 páginas',
  cover: 'https://cdn.magicpatterns.com/uploads/4gJhTbKJmSEuHqHdh1oYqc/ChatGPT_Image_25_ago_2026,_14_59_11_(1).png'
}, {
  number: '05',
  title: 'Masterclass: El Negocio',
  pages: '20 páginas',
  cover: 'https://cdn.magicpatterns.com/uploads/bxV4saXi7me9FPygSU7TMG/ChatGPT_Image_25_ago_2026,_14_59_20.png'
}];
export function PackContents() {
  return <Section id="contenido" className="relative" data-id="element-215" data-mp="2h0mjg87ijjfa">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" data-id="element-216" data-mp="2h1xnm94vet6x">
        <Blossom className="absolute right-[4%] top-10 h-24 w-24 text-brand-roseMist" data-id="element-217" data-mp="2c6ic3nuc59do" />
        <Blossom className="absolute left-[3%] top-1/2 h-20 w-20 text-brand-lavenderMist" data-id="element-218" data-mp="277p7kkx10spn" />
      </div>

      <div className="mb-4 text-center" data-id="element-219" data-mp="34r0e86hhfwdk">
        <p className="mb-2 text-sm font-bold uppercase tracking-[.18em] text-brand-goldDark" data-id="element-220" data-mp="2zy78bfaa2hzw">✨ Todos los niveles</p>
        <h2 className="font-display text-3xl font-bold text-brand-green md:text-5xl" data-id="element-221" data-mp="2kfmqozk0ji4r">
          2 Tomos Principales + 5 Bonus Estratégicos
        </h2>
        <p className="mt-3 text-base text-brand-muted md:text-lg" data-id="element-222" data-mp="2ai9pb16ko59l">
          Más de 150 páginas — Todo lo que necesitás resuelto.
        </p>
      </div>

      <p className="mx-auto mb-10 max-w-2xl text-center text-sm leading-relaxed text-brand-textLight md:text-base" data-id="element-223" data-mp="2fi4i5a9wr4xa">
        Ya sea que estés comenzando con Flores de Bach o que ya atiendas pacientes y quieras hacerlo con más criterio,
        seguridad y estructura profesional, <strong className="text-brand-greenMid" data-id="element-224" data-mp="2thw01m3jp5gk">el Botiquín Bach fue creado para vos</strong>.
      </p>

      <div className="mx-auto grid max-w-6xl gap-6 lg:grid-cols-2" data-id="element-225" data-mp="2yffcqhklha6e">
        {tomes.map(tome => {
        const Icon = tome.icon;
        return <article key={tome.label} className="paper-panel flex h-full flex-col rounded-3xl p-6 md:p-8" data-id="element-226" data-mp="3m3yml1jalv0l">
              <div className="mb-5 flex flex-col gap-5 sm:flex-row sm:items-start" data-id="element-227" data-mp="1fhj4b20y8tfo">
                <div className="mx-auto w-36 shrink-0 sm:mx-0 sm:w-40" data-id="element-228" data-mp="1ffg3dmy9dfw6">
                  <div className="overflow-hidden rounded-xl border border-brand-green/15 bg-white shadow-[0_10px_24px_rgba(14,42,30,.14)]" data-id="element-229" data-mp="1ahwruusy3h7x">
                    <img src={tome.cover} alt={tome.coverAlt} loading="lazy" className="block h-auto w-full" draggable={false} data-id="element-230" data-mp="1k897q9ptem7q" />
                  </div>
                </div>
                <div className="min-w-0 flex-1" data-id="element-231" data-mp="15jd0ufzhvf8p">
                  <div className="mb-2 flex items-center gap-2" data-id="element-232" data-mp="15k4rrdi5cosn">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-brand-green text-brand-goldLight ring-1 ring-brand-gold/40" data-id="element-233" data-mp="11h8bvujzr6se">
                      <Icon className="h-4 w-4" data-id="element-234" data-mp="2h0cupg1hq24u" />
                    </span>
                    <p className="text-[11px] font-bold tracking-[.18em] text-brand-goldDark" data-id="element-235" data-mp="2cwdeyzo1b7cj">{tome.label}</p>
                  </div>
                  <h3 className="font-serif text-xl font-bold leading-tight text-brand-green md:text-2xl" data-id="element-236" data-mp="1el3v78ypjtlo">
                    {tome.title}
                  </h3>
                  <p className="mt-1.5 text-xs italic leading-snug text-brand-muted md:text-sm" data-id="element-237" data-mp="1jkotri9ytzxv">{tome.subtitle}</p>
                  <div className="leaf-rule mt-4" aria-hidden="true" data-id="element-238" data-mp="1njo8fuli1b2i" />
                </div>
              </div>
              <ul className="space-y-2.5 text-sm leading-snug text-brand-text" data-id="element-239" data-mp="qtont1s2qm3k">
                {tome.features.map(feature => <li key={feature} className="flex gap-2.5" data-id="element-240" data-mp="zvo5zxetrw83">
                    <span className="font-bold text-brand-greenMid" data-id="element-241" data-mp="zu3fqjzjmzg1">✓</span>
                    <span data-id="element-242" data-mp="14ohb4me7h6kp">{feature}</span>
                  </li>)}
              </ul>
            </article>;
      })}
      </div>

      <div className="mb-6 mt-14 text-center" data-id="element-243" data-mp="c63mnderewya">
        <h3 className="font-serif text-xl font-bold text-brand-green md:text-2xl" data-id="element-244" data-mp="c4sjnft51t88">
          🎁 5 BONUS ESTRATÉGICOS — <span className="text-brand-goldDark" data-id="element-245" data-mp="4l02uzslyoje">SIEMPRE INCLUIDOS</span>
        </h3>
      </div>

      <div className="mx-auto grid max-w-5xl grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5" data-id="element-246" data-mp="3vu6z4ci2zzvh">
        {bonuses.map(bonus => <article key={bonus.number} className="flex flex-col overflow-hidden rounded-2xl border border-brand-green/20 bg-brand-parchment text-center" data-id="element-247" data-mp="3mspgamdahk33">
            <div className="relative aspect-[5/7] w-full overflow-hidden bg-white" data-id="element-248" data-mp="3hvgw6g8kz5z7">
              <img src={bonus.cover} alt={`Portada del Bonus ${bonus.number}: ${bonus.title}`} loading="lazy" className="h-full w-full object-cover object-top" draggable={false} data-id="element-249" data-mp="3d0t9mmx50ln9" />
              <span className="absolute left-2 top-2 rounded-full bg-brand-green px-2.5 py-1 text-[9px] font-bold tracking-wide text-brand-goldLight" data-id="element-250" data-mp="2z2lfsnvee0gb">
                BONUS {bonus.number}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-3" data-id="element-251" data-mp="lt91ydx0iq3n">
              <p className="text-[13px] font-bold leading-tight text-brand-text" data-id="element-252" data-mp="qtdnwjgowd19">{bonus.title}</p>
              <p className="mt-auto pt-2 text-[11px] font-semibold text-brand-goldDark" data-id="element-253" data-mp="ctm23wjxlscp">{bonus.pages}</p>
            </div>
          </article>)}
      </div>

      <div className="mt-8 text-center" data-id="element-254" data-mp="34uf82tq9y8n">
        <p className="inline-block rounded-full border border-brand-gold/60 bg-white px-5 py-3 text-sm font-medium text-brand-text" data-id="element-255" data-mp="342halcnrof7">
          Todo el valor de los bonus <span className="font-bold text-brand-greenMid" data-id="element-256" data-mp="3q9tr1ujs0fsb">incluido con tu Botiquín Bach</span>
        </p>
      </div>
    </Section>;
}